<template>
  <div>
    <!-- <AppHeader v-if="isHeader">
      <router-link slot="left" to="/" class="logolink">
        <img :src="assetsPath +'static/images/logo.png'" style="display:inline-block; height:2rem;">
      </router-link>
    </AppHeader> -->
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <!-- <AppFooter /> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import AppHeader from './app-header';
import AppFooter from './app-footer';
import tools from '@/utils/tools';
export default {
  mixins: [tools],
  componentName: 'apphome',
  components: {
    AppHeader, AppFooter
  },
  props: {
    token: String
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['backUrl']),
    isHeader() {
      return !(this.$route.path.startWith('/personal'));
    }
  },
  watch: {
    token() {
      // this.login4Token();
    }
  },
  mounted () {
  },
  activated() {
    this.login4Token();
    // let backUrl = this.backUrl;
    // 登录后的跳转链接，跳转并清除跳转链接
    // if (backUrl) {
      // console.log(backUrl)
    //   this.$store.commit(types.JY_BACKURL_CLEAR);
    //   this.$router.push(backUrl);
    // }
  },
  methods: {
    login4Token() {
      // console.log(this.token)
      if (this.token) {
        this.$store.dispatch(types.JY_LOGIN_MEMBER, {
          newtoken: this.token,
          callback: (flag) => {
            console.log(flag, this.backUrl)
            if (flag) {
              let backUrl = this.backUrl;
              if (backUrl) {
                this.$store.commit(types.JY_BACKURL_CLEAR);
                this.$router.push(backUrl);
              }
            }
          }
        });
      }
    },
  }
}
</script>
<style lang="less" scoped>
.logolink {
  .flex-center-v();
}
</style>